/* Dust & Mile cart drawer helpers + "Pairs great with" rail.
 * Loaded by snippets/cart-drawer.liquid and sections/dm-cart-page.liquid (guarded, safe to load twice).
 * Dawn's assets/cart-drawer.js (patched) calls window.dmCart.* hooks.
 */
(function () {
  if (window.dmCart) return;

  var LAST_ADDED_KEY = 'dm:last-added-item';
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function readLastAdded() {
    try {
      var raw = window.sessionStorage.getItem(LAST_ADDED_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeLastAdded(item) {
    if (!item || !item.product_id) return;
    try {
      window.sessionStorage.setItem(
        LAST_ADDED_KEY,
        JSON.stringify({
          key: item.key || null,
          product_id: String(item.product_id),
          variant_id: item.variant_id || item.id || null,
          at: Date.now(),
        })
      );
    } catch (e) {
      /* storage blocked: recommendations fall back to the first line item */
    }
  }

  /* Accepts a /cart/add.js response: a single line item, or { items: [...] } for multi-adds. */
  function rememberAdded(state) {
    if (!state) return;
    if (Array.isArray(state.items) && state.items.length) {
      writeLastAdded(state.items[state.items.length - 1]);
    } else if (state.product_id) {
      writeLastAdded(state);
    }
  }

  /* ---------- scroll keeping across Dawn re-renders ---------- */
  var lastBodyScroll = 0;
  var resetScrollOnce = false;

  function bodyEl() {
    return document.querySelector('cart-drawer [data-dm-drawer-body]');
  }

  document.addEventListener(
    'scroll',
    function (event) {
      var t = event.target;
      if (t && t.matches && t.matches('cart-drawer [data-dm-drawer-body]')) lastBodyScroll = t.scrollTop;
    },
    true
  );

  function syncDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var dm = drawer.querySelector('.dm-drawer');
    if (dm) drawer.classList.toggle('is-empty', dm.classList.contains('dm-drawer--empty'));
    var body = bodyEl();
    if (body) {
      if (resetScrollOnce) {
        body.scrollTop = 0;
        lastBodyScroll = 0;
        resetScrollOnce = false;
      } else {
        body.scrollTop = lastBodyScroll;
      }
    }
  }

  /* Any time Dawn swaps the drawer markup, re-sync empty state and scroll. */
  function observeDrawer() {
    var target = document.getElementById('CartDrawer');
    if (!target || target.dataset.dmObserved) return;
    target.dataset.dmObserved = 'true';
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) {
          syncDrawer();
          break;
        }
      }
    }).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer);
  } else {
    observeDrawer();
  }

  window.dmCart = {
    rememberAdded: rememberAdded,
    readLastAdded: readLastAdded,
    sync: syncDrawer,
    resetScroll: function () {
      resetScrollOnce = true;
    },
    sectionHTML: function (html, selector) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var node = doc.querySelector(selector || '.shopify-section');
      return node ? node.innerHTML : null;
    },
    /* Re-render the drawer + bubble from a sections payload without opening the drawer. */
    renderSections: function (sections) {
      if (!sections) return;
      var drawer = document.querySelector('cart-drawer');
      if (sections['cart-drawer'] && drawer) {
        var inner = window.dmCart.sectionHTML(sections['cart-drawer'], '#CartDrawer');
        var target = document.getElementById('CartDrawer');
        if (inner !== null && target) target.innerHTML = inner;
        syncDrawer();
      }
      if (sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        var bubbleHTML = window.dmCart.sectionHTML(sections['cart-icon-bubble'], '.shopify-section');
        if (bubble && bubbleHTML !== null) bubble.innerHTML = bubbleHTML;
      }
    },
  };

  /* ---------- <dm-cart-recommendations> ---------- */
  var recsCache = new Map();
  var recsPending = new Map();

  if (!customElements.get('dm-cart-recommendations')) {
    class DmCartRecommendations extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-dm-recs-rail]');
        this.prev = this.querySelector('[data-dm-recs-prev]');
        this.next = this.querySelector('[data-dm-recs-next]');
        if (!this.rail) return;

        this.cartIds = (this.dataset.cartProductIds || '').split(',').filter(Boolean);
        this.seed = this.pickSeed();
        this.cacheKey = this.seed + '|' + this.cartIds.slice().sort().join(',');

        this.onScroll = this.updateArrows.bind(this);
        this.rail.addEventListener('scroll', this.onScroll, { passive: true });
        this.prev && this.prev.addEventListener('click', () => this.step(-1));
        this.next && this.next.addEventListener('click', () => this.step(1));
        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        this.resizeObserver.observe(this.rail);

        if (recsCache.has(this.cacheKey)) {
          this.render(recsCache.get(this.cacheKey));
          return;
        }
        this.armLazyLoad();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.io) this.io.disconnect();
        if (this.openHandler) document.removeEventListener('dm:cart-drawer:open', this.openHandler);
      }

      pickSeed() {
        var last = readLastAdded();
        if (last && last.product_id && this.cartIds.indexOf(String(last.product_id)) !== -1) {
          return String(last.product_id);
        }
        return this.dataset.seedProductId || this.cartIds[0] || '';
      }

      armLazyLoad() {
        if (this.dataset.context === 'drawer') {
          var drawer = this.closest('cart-drawer');
          if (drawer && drawer.classList.contains('active')) {
            this.load();
          } else {
            this.openHandler = () => {
              document.removeEventListener('dm:cart-drawer:open', this.openHandler);
              this.openHandler = null;
              this.load();
            };
            document.addEventListener('dm:cart-drawer:open', this.openHandler);
          }
        } else if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            (entries) => {
              if (entries.some((e) => e.isIntersecting)) {
                this.io.disconnect();
                this.load();
              }
            },
            { rootMargin: '400px 0px' }
          );
          this.io.observe(this.parentElement || this);
        } else {
          this.load();
        }
      }

      load() {
        if (this.loading || !this.seed) return;
        this.loading = true;
        var base = this.dataset.url || '/recommendations/products';
        var section = this.dataset.section || 'dm-cart-recommendations';
        var url =
          base +
          '?section_id=' +
          encodeURIComponent(section) +
          '&product_id=' +
          encodeURIComponent(this.seed) +
          '&limit=10&intent=related';
        var root = (this.dataset.rootUrl || '/').replace(/\/?$/, '/');
        var fallbackUrl = root + '?section_id=' + encodeURIComponent(section);

        var key = this.cacheKey;
        var request = recsPending.get(key);
        if (!request) {
          request = fetch(url)
            .then((r) => {
              if (!r.ok) throw new Error('recs ' + r.status);
              return r.text();
            })
            .catch(() => fetch(fallbackUrl).then((r) => r.text()))
            .then((html) => {
              var cards = this.pickCards(html);
              recsCache.set(key, cards);
              return cards;
            })
            .finally(() => recsPending.delete(key));
          recsPending.set(key, request);
        }
        request
          .then((cards) => {
            if (this.isConnected) this.render(cards);
          })
          .catch(() => {
            /* leave the rail hidden */
          })
          .finally(() => {
            this.loading = false;
          });
      }

      pickCards(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var max = parseInt(this.dataset.max, 10) || 8;
        var seen = new Set(this.cartIds);
        var out = [];
        doc.querySelectorAll('.dm-rec-card[data-product-id]').forEach((card) => {
          var id = card.getAttribute('data-product-id');
          if (out.length >= max || seen.has(id)) return;
          seen.add(id);
          out.push(card.outerHTML);
        });
        return out;
      }

      render(cards) {
        if (!cards || !cards.length) {
          this.hidden = true;
          return;
        }
        this.rail.innerHTML = cards.join('');
        this.hidden = false;
        this.rail.scrollLeft = 0;
        requestAnimationFrame(() => this.updateArrows());
      }

      step(dir) {
        var amount = this.rail.clientWidth * 0.9 * dir;
        this.rail.scrollBy({ left: amount, behavior: reducedMotion ? 'auto' : 'smooth' });
      }

      updateArrows() {
        if (!this.rail || !this.prev || !this.next) return;
        var max = this.rail.scrollWidth - this.rail.clientWidth;
        var x = Math.abs(this.rail.scrollLeft);
        this.prev.disabled = x <= 2;
        this.next.disabled = x >= max - 2;
        this.classList.toggle('dm-recs--no-overflow', max <= 2);
      }
    }

    customElements.define('dm-cart-recommendations', DmCartRecommendations);
  }
})();
